import React from 'react';
import { motion } from 'framer-motion';

/**
 * RevealEffect - wraps any media child and applies a cinematic reveal:
 *   • L→R gradient wipe (clip-path)
 *   • saturate→normal pulse + slight scale settle
 *   • a violet scan-line that sweeps top→bottom once
 *
 * Used for newly-completed image/video/music/chat outputs.
 * Pass `active` to (re)trigger; bumping the `id` prop also restarts.
 */
export function RevealEffect({ active = true, id, children, style }) {
  return (
    <motion.div
      key={id}
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      style={{
        position: 'relative',
        display: 'inline-block',
        ...style,
      }}
    >
      <div className={active ? 'dgw-reveal-wipe' : ''}>
        {children}
      </div>
      {active && (
        <span
          aria-hidden
          className="dgw-scan-line"
          style={{
            position: 'absolute',
            left: 0, right: 0,
            height: 2,
            top: 0,
            background: 'linear-gradient(90deg, transparent, rgba(167,139,250,0.9), rgba(236,72,153,0.7), transparent)',
            filter: 'blur(0.5px)',
            pointerEvents: 'none',
            mixBlendMode: 'screen',
            zIndex: 4,
          }}
        />
      )}
    </motion.div>
  );
}
